import { render } from "./uninstalled.vue?vue&type=template&id=7b334722&lang=pug"
import script from "./uninstalled.vue?vue&type=script&lang=js"
export * from "./uninstalled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__